import { AgencyApprovalStatus } from '../api/agency-api';

export const agencyApprovalStatuses = [
  AgencyApprovalStatus.Submitted,
  AgencyApprovalStatus.Approved,
  AgencyApprovalStatus.Rejected,
  AgencyApprovalStatus.Under_Review,
  AgencyApprovalStatus.Not_Submitted,
];
